"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMaintenance = exports.fetchLearnMore = exports.fetchContent = exports.fetchContact = exports.clearMaintenanceContent = void 0;
var _types = _interopRequireDefault(require("./types"));
var _environment = _interopRequireDefault(require("../../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* ACTION CREATOR FUNCTIONS
Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects
*/

var getContentUrl = _environment.default.CONTENT.getContentUrl;
var fetchContact = exports.fetchContact = function fetchContact() {
  return {
    type: _types.default.FETCH_CONTACT_REQUEST,
    meta: {
      async: true,
      blocking: true,
      url: getContentUrl + 'contact-page',
      method: 'GET'
    }
  };
};
var fetchContent = exports.fetchContent = function fetchContent(categoryName) {
  return {
    type: _types.default.FETCH_CONTENT_REQUEST,
    meta: {
      async: true,
      blocking: true,
      url: getContentUrl + categoryName,
      method: 'GET'
    }
  };
};
var fetchLearnMore = exports.fetchLearnMore = function fetchLearnMore() {
  return {
    type: _types.default.FETCH_LEARN_MORE_REQUEST,
    meta: {
      async: true,
      blocking: true,
      url: getContentUrl + 'learn-more',
      method: 'GET'
    }
  };
};
var fetchMaintenance = exports.fetchMaintenance = function fetchMaintenance() {
  return {
    type: _types.default.FETCH_MAINTENANCE_REQUEST,
    meta: {
      async: true,
      blocking: true,
      url: getContentUrl + 'maintenance/mobile',
      method: 'GET'
    }
  };
};
var clearMaintenanceContent = exports.clearMaintenanceContent = function clearMaintenanceContent() {
  return {
    type: _types.default.MAINTENANCE_CONTENT_CLEAR,
    meta: {
      blocking: false
    }
  };
};